<template>
  <div class="wrapper">
    <div class="bgc">
      <div class="shop-container">
        <div class="nav-bread">
          <router-link to="/">{{ $t("home") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'exam' }">{{ $t("exam") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'examitem', params: { id: form.plan_id } }">{{ topTitle }}</router-link>
          <span>></span>
          <span>{{ "成绩" }}</span>
        </div>
        <div class="exam-box" v-loading="loading">
            <div class="title">{{ topTitle }}</div>
          <div v-if="startList.length > 0">
            <div class="list" v-for="(item, index) in startList" :key="index">
              <div class="card">
                <div class="card_body">
                  <div style="display: flex; justify-content: space-between; align-items: center">
                    <div class="content-text" style="width: 18%;"><span style="color: black">考试成绩：</span>{{ item.total_score }}</div>
                    <div class="content-text" style="width: 18%;"><span style="color: black">考试用时：</span>{{ dateformat(item.exam_timetype_id) }}</div>
                    <div class="content-text" style="width: 20%;"><span style="color: black">考试类型：</span>{{ item.make_up_exam }}</div>
                    <div class="content-text" style="width: 18%;"><span style="color: black">考试结果：</span>{{ item.is_pass }}</div>
                    <div class="content-text" style="margin-bottom: 0; width: 26%"><span style="color: black">考试时间：</span>{{ item.ctime }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="padding-top: 100px; width: 100%; text-align: center" v-else>
            {{ nodata }}
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-wrap" v-if="total > 0">
      <pagination :totalPage="total" :limit="10" @changePage="changePage" />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      topTitle: "",
      loading: false,
      nodata: "暂无成绩记录",
      count: 0,
      startList: [],
      paper_id: "",
      form: {
        page: 1,
        limit: 10,
        plan_id: 0,
      },
      total: 0,
    };
  },
  mounted() {
    this.form.plan_id = this.$route.params.id;
    this.loading = true;
    this.topTitle = this.$route.params.title;
    this.init();
  },

  computed: {
    dateformat(value) {
      return (value) => {
        let result = parseInt(value);
        let h = Math.floor(result / 3600) < 10 ? "0" + Math.floor(result / 3600) : Math.floor(result / 3600);
        let m = Math.floor((result / 60) % 60) < 10 ? "0" + Math.floor((result / 60) % 60) : Math.floor((result / 60) % 60);
        let s = Math.floor(result % 60) < 10 ? "0" + Math.floor(result % 60) : Math.floor(result % 60);
        result = `${h}:${m}:${s}`;
        return result;
      };
    },
  },
  methods: {
    init() {
      var params = {
        ...this.form,
      };
      this.$api.achievementList(params).then((res) => {
        if (res.status) {
          this.startList = res.data.list;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
        this.loading = false;
      });
    },
    changePage(v) {
      this.form.page = v;
      this.init();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";

.wrapBox {
  width: 428px;
  padding: 0 11px;

  .list {
    width: 100%;
    // padding:0 0 23px ;
    color: rgb(10, 33, 51);
    font-size: 16px;
    font-weight: 400;
    line-height: 23px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-line-clamp: 2;
    border-bottom: 1px solid rgb(243, 244, 245);
    margin-bottom: 23px;
  }
  .content-text {
    width: 405px;
    height: 23px;
    color: rgb(108, 122, 133);
    font-size: 16px;
    font-weight: 400;
    line-height: 23px;
    margin-bottom: 16px;
  }
  .content-text:last-child {
    margin-bottom: 0 !important;
  }
}
.exam-box {
  width: 100%;
  height: auto;
  padding: 52px 20px 40px;
  background-color: white;
  box-sizing: border-box;
  .title {
    width: 100%;
    height: 33px;
    line-height: 33px;
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 30px;
  }
  .text_prc {
    width: 100%;
    // height: 22px;
    line-height: 22px;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    .text_prc_left {
      width: 40%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: left;
      .text_prc_left_title {
        margin-bottom: 32px;
        height: 22px;
        padding-left: 100px;
      }
    }
  }
}
.class-list {
  // background: #ffffff;
  width: 1226px;
  margin: 20px auto 0;
  // padding: 30px;
  margin-bottom: 20px;
  box-sizing: border-box;
}
.class-title {
  color: #333333;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    display: inline-block;
    width: 6px;
    height: 38px;
    background: #ff6d6d;
    border-radius: 4px;
    margin-right: 7px;
  }
  .title-wrap {
    display: flex;
    align-items: center;
  }
}
.tr-foot {
  display: flex;
  // position: absolute;
  justify-content: center;
  margin-bottom: 40px;
  .btn {
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    width: 180px;
    text-align: center;
    border: 1px solid $theme-color;
    margin-right: 20px;
    cursor: pointer;
    &.add-btn {
      color: $theme-color;
    }
    &.buy-btn {
      background: $theme-color;
      color: #fff;
    }
    &.sold-out {
      background: $theme-color;
      color: #fff;
      cursor: not-allowed;
      border: none;
    }
    &.disabled {
      background-color: rgb(245, 127, 112);
    }
  }
  .collete-btn {
    min-width: 45px;
    height: 47px;
    text-align: center;
    // padding-top: 5px;
    padding: 5px 5px;
    box-sizing: border-box;
    font-size: 12px;
    background: #fff;
    border: 1px solid $border;
    color: #bebebe;
    cursor: pointer;
    color: $theme-color;
    .icon {
      display: block;
      margin-bottom: 4px;
    }
    &:hover {
      color: $theme-color;
    }
  }
}
.list {
  width: 100%;
  padding: 0 0 23px;
  color: rgb(10, 33, 51);
  font-size: 16px;
  font-weight: 400;
  line-height: 23px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-line-clamp: 2;
  border-bottom: 1px solid rgb(243, 244, 245);
  margin-bottom: 23px;
  &:last-child {
    border-bottom: 0px solid rgb(243, 244, 245);
  }
}
.card {
  //   width: 60%;
  padding: 26px 20px 23px;
  margin: 0 0 20px;
  background: #ffffff;
  .card_body {
    .card_tab {
      position: relative;
      width: 100%;
      height: 22px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(49, 44, 44, 1);
      line-height: 22px;
      margin-bottom: 27px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      i {
        width: 4px;
        height: 16px;
        display: inline-div;
        background-color: rgba(231, 68, 47, 1);
        margin-right: 8px;
      }
    }
    .person-con {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 80%;
      height: 60px;

      .icon-bg {
        .icon {
          width: 60px;
          height: 60px;
          display: inline-div;
          border-radius: 50%;
          box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.2);
          border: 1px solid white;
          margin-right: -12px;
        }
      }
    }

    .btn_arrow {
      width: 80px;
      height: 32px;
      background-color: #f2f3f3;
      border-radius: 100px;
      color: #808080;
      font-size: 10px;
      text-align: center;
      line-height: 32px;
    }
    .btn {
      width: 95%;
      height: 52px;
      background-color: rgba(250, 250, 250, 1);
      color: rgba(49, 44, 44, 1);
      font-size: 14px;
      line-height: 52px;
      text-align: left;
      padding-left: 18px;
      img {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
    }
    .btns {
      display: flex;
      justify-content: space-between;

      .defaultBtn {
        width: 165px;
        height: 52px;
        background-color: rgba(250, 250, 250, 1);
        color: rgba(49, 44, 44, 1);
        font-size: 14px;
        line-height: 52px;
        text-align: center;
      }
    }
    .pic_bg {
      width: 100%;
      height: 150px;
      margin-bottom: 20px;
    }
    .line {
      width: 100%;
      border: 1px solid rgba(242, 241, 241, 1);
      margin-bottom: 20px;
    }
    .product-name {
      height: 20px;
      font-size: 14px;
      text-align: left;
      line-height: 20px;
      margin-bottom: 20px;
      font-weight: 600;
    }
    .product-icon {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-bottom: 20px;

      .item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .icon {
          width: 26px;
          height: 26px;
          display: div;
          margin-bottom: 9px;
        }
      }
    }

    .img-zxc {
      width: 100%;
      height: auto;
      position: relative;
      margin-bottom: 5px;
      font-size: 14px;
      line-height: 20px;

      img {
        max-width: 100% !important;
        height: auto;
      }
      p {
        width: 100%;

        img {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
